import { v4 } from 'uuid'

import { isTestEnv } from 'utils/e2e'

export const getSessionId = () => (isTestEnv() ? 'ui-test-assistant-session-2' : v4())
